import { Typography } from 'components/generic/typography';
import styled, { css } from 'styled-components';
import Icon from 'components/Icon';
import type { ReactNode } from 'react';
import { breakpoint } from 'variables';

type StockInfoItemProps = {
    heading?: string;
    iconType: 'Store' | 'Delivery' | 'Bell';
    showArrow?: boolean;
    infoRenderer?: () => ReactNode;
    onClick?: () => void;
};

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${({ theme }) => theme.Spacing8};
    padding: ${({ theme }) => theme.Spacing16};
    border: none;
    text-decoration: none;
    text-align: left;
    width: 100%;
    background: transparent;

    & + & {
        border-top: 1px solid ${({ theme }) => theme.ColorBorderSecondary};
    }

     ${({ theme }) => theme.StockInfoItemContainer}
`;

const Content = styled.div<{ $hasInfo?: boolean }>`
    display: grid;
    column-gap: ${({ theme }) => theme.Spacing8};
    row-gap: ${({ theme }) => theme.Spacing4};

    ${({ $hasInfo }) =>
        $hasInfo
            ? css`
                grid-template-areas:         
                    'icon heading'
                    'icon info'
            ;`
            : css`
                grid-template-areas:
                    'icon heading';
                `}

    ${breakpoint.up('768px')} {
        column-gap: ${({ theme }) => theme.Spacing16};
    }
`;

const Heading = styled(Typography.Body)`
    grid-area: heading;
    margin-top: ${({ theme }) => theme.Spacing2};
`;

const StyledIcon = styled(Icon)`
    ${({ theme }) => theme.ChevronIcon}
`;

export default function StockInfoItem(props: StockInfoItemProps) {
    const { heading, infoRenderer, iconType, showArrow = true, onClick } = props;

    const buttonProps = onClick ? { as: 'button', onClick, type: 'button' } : {};

    return (
        <Container {...buttonProps}>
            <Content $hasInfo={!!infoRenderer}>
                <Icon type={iconType} size={24} />
                {heading && <Heading strong>{heading}</Heading>}
                {infoRenderer?.()}
            </Content>
            {showArrow && <StyledIcon type="ChevronRight" size={16} />}
        </Container>
    );
}
